<template>
    <div class="return">
        <img class="backBtn" @click="clickGoOver" src="../assets/img/backIcon.png" alt />
        <div v-if="status==0" class="main">
            <img src="../assets/img/pic/phone/suc.png" class="returnPic">
            <p class="msg" style="text-align:center;">{{ msg }}</p>
            <div class="Btn"  @click="clickGoIndex">Complete</div>
        </div>
        <div v-if="status==1" class="main">
            <img src="../assets/img/pic/phone/err.png" class="returnPic">
            <p class="fail">Fail!</p>
            <p class="msg" style="margin-top:15px;text-align:center;">{{ msg }}</p>
            <div class="Btn"  @click="clickGoOver">Return</div>
        </div>
        <div v-if="status==2" class="main">
            <img src="../assets/img/pic/phone/wr.png" class="returnPic">
            <p class="msg" style="text-align:center;">{{ msg }}</p>
            <div class="Btns">
                <div class="Btn1"  @click="checkStatus" style="margin-right:15px;"> Check Status</div>
                <div class="Btn1"  @click="clickGoOver">Continues</div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        Toast,
    } from "mint-ui";
    import FadeLoader from 'vue-spinner/src/FadeLoader.vue';
    import { CheckStatus } from "@/api/account";
    export default {
        data() {
            return {
                status: null,
                msg: '',
                tag: '',
            };
        },
        components: {
            Toast,
            FadeLoader,
        },
        methods: {

            clickGoIndex() {
                this.$router.push("/index");
            },
            clickGoOver() {
                this.$router.push("/index");
            },
            checkStatus() {
                // 检查核销结果
                CheckStatus({
                    user_tag: this.tag,
                }).then((data) => {
                    this.msg = data.msg
                    if (data.code === 0) {
                        // 失败
                        this.status = 1;
                    } else {
                        this.status = 0;
                    }
                })
            }
        },

        created() {
            console.log(this.$route.query.status)
            if (this.$route.query.status) {
                this.status = this.$route.query.status
                this.msg = this.$route.query.msg
                //console.log(this.status);
                //this.tag = this.$route.query.tag
            }
        },
        mounted() {

        },
    };
</script>
<style lang="less" scoped>
    @font-face {
        font-family: "PingFang-SC-Heavy";
        src: url("../assets/font/PingFang Heavy.otf");
    }

    @font-face {
        font-family: "PingFang-SC-Medium";
        src: url("../assets/font/PingFang Medium_downcc.otf");
    }

    @font-face {
        font-family: "PingFang-SC-Bold";
        src: url("../assets/font/苹方 粗体.ttf");
    }

    .return {
        .backBtn {
            width: 6px;
            height: 12px;
            margin: 12px 0 0 12px;
        }

        .main {
            display: flex;
            flex-direction: column;
            align-content: center;
            align-items: center;

            .returnPic {
                margin-top: 100px;
                width: 60px;
                height: 60px;
            }

            .fail {
                font-family: PingFang-SC-Medium;
                font-size: 18px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #ff4949;
                margin-top: 20px;

            }

            .Btns {
                display: flex;
                // width: 80%;
                margin: auto;
                margin-top: 60px;

                .Btn1 {
                    width: 120px;
                    height: 40px;
                    background-color: rgba(255, 153, 0, .1);
                    border-radius: 4px;
                    text-align: center;
                    font-family: PingFang-SC-Medium;
                    font-size: 14px;
                    line-height: 40px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #ff9900;
                }
            }

            .Btn {
                width: 43%;
                height: 40px;
                background-color: rgba(255, 153, 0, .1);
                border-radius: 4px;
                text-align: center;
                font-family: PingFang-SC-Medium;
                font-size: 14px;
                line-height: 40px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #ff9900;
                margin-top: 60px;
            }

            .msg {
                font-family: PingFang-SC-Medium;
                font-size: 18px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #1c1c1c;
                margin-top: 20px;
            }
        }
    }
</style>